<template>
    <div>

        <PageHeader>
            {{ $t('catalog') }} - {{ $t('productVariants') }}
        </PageHeader>

        <Filters />

        <Results />

    </div>
</template>



<script>
    import viewFiltersMixin from '@/mixins/viewFiltersMixin';
    import Filters from './parts/Filters.vue';
    import Results from './parts/Results.vue';

    const DEFAULT_FILTERS_PARAMS = Object.freeze({
        gtins: [],
        code: null,
        product: null,
        manufacturer: null,
        url: '',
        description: '',
    });
    const DEFAULT_TABLE_PARAMS = Object.freeze({
        perPage: 25,
        page: 1,
        order: 'DESC',
    });

    export default {
        name: 'ProductVariants',
        mixins: [viewFiltersMixin],
        components: {
            Filters,
            Results,
        },
        provide() {
            return {
                parentComponent: this,
            };
        },
        data() {
            return {
                ...this.initParams(DEFAULT_FILTERS_PARAMS, DEFAULT_TABLE_PARAMS),
                request: this.$req('catalog/variants'),
                requestProducts: this.$req('catalog/products'),
                requestDuplicates: this.$req('catalog/duplicates'),
            };
        },
        computed: {
            loading() {
                return this.request.getLoading();
            },
        },
    };
</script>
